import React, { useCallback } from 'react';
import { Button, Cards } from '@amzn/awsui-components-console';

interface ButtonItem {
	text: string;
	href: string;
}

interface CardItem {
	id: string;
	header: string;
	description: string;
	buttons: ButtonItem[];
}

const CARD_ITEMS: CardItem[] = [
	{
		id: 'about-us',
		header: 'About Us',
		description:
			'Find more about us! Find out what SNOW is, what are its capabilities and the business currently supported in SNOW.',
		buttons: [
			{ text: 'About SNOW', href: 'https://w.amazon.com/bin/view/SNOWHome' },
			{ text: 'Our Team', href: 'https://w.amazon.com/bin/view/SNOW/Team' },
			{
				text: 'Office Hours',
				href: 'https://w.amazon.com/index.php/SNOW/OfficeHours',
			},
		],
	},
	{
		id: 'customer-questions',
		header: 'Customer Questions?',
		description:
			'Hope you can find the answers on our FAQ pages. If not, look for similar questions in SAGE or ask your own!',
		buttons: [
			{ text: 'FAQ Wiki', href: 'https://w.amazon.com/bin/view/SNOW/FAQs' },
			{ text: 'Snow Sage', href: 'https://sage.amazon.com/tags/SNOW' },
		],
	},
	{
		id: 'found-bugs',
		header: 'Found Bugs?',
		description:
			'We do our best to ensure that all use cases are covered with every feature we release but when you find bugs please let us know. It can be as small as a cosmetic UI change or a constant bug, no task is too small or too big!',
		buttons: [
			{
				text: 'File a bug',
				href: 'https://tiny.amazon.com/1k10o7m8w/riveamazHYD1work',
			},
		],
	},
	{
		id: 'feature-requests',
		header: 'Feature Requests?',
		description:
			"Have you ever wondered how to suggest awesome features or changes to the Snow team? We are always open to discuss ideas on how to improve our customer's lives. Submit a feature request now!",
		buttons: [
			{
				text: 'Request a feature',
				href: 'https://tiny.amazon.com/1gpvg12x/feature',
			},
			{
				text: 'Onboard New Business',
				href: 'https://tiny.amazon.com/1sazimlg/business',
			},
		],
	},
	{
		id: 'user-guide',
		header: 'Wondering how to start the new workflow?',
		description:
			'Please find the SNOW user guides and other useful information that a user need to know for best customer experience.',
		buttons: [
			{
				text: 'User Guide',
				href: 'https://w.amazon.com/bin/view/SNOW/UserGuide',
			},
		],
	},
	{
		id: 'slack-channel',
		header: 'Slack Channel',
		description:
			'Join the Snow community to discuss all about Launches! Ask questions or send quick feedback straight to the snow team!',
		buttons: [
			{
				text: 'Snow Interest',
				href: 'https://amzn-security.slack.com/app_redirect?channel=snow-interest',
			},
		],
	},
];

const CARDS_PER_ROW = [{ cards: 1 }, { minWidth: 500, cards: 2 }];

const ACTIONS_CONTAINER_STYLE: React.CSSProperties = {
	display: 'flex',
	flexWrap: 'wrap',
	gap: '8px',
};

const Contact: React.FC = () => {
	const renderCardHeader = useCallback((item: CardItem) => item.header, []);

	const renderCardDescription = useCallback(
		(item: CardItem) => <p>{item.description}</p>,
		[]
	);

	const renderCardActions = useCallback(
		(item: CardItem) => (
			<div style={ACTIONS_CONTAINER_STYLE}>
				{item.buttons.map((button, index) => (
					<Button
						key={`${item.id}-button-${index}`}
						target="_blank"
						href={button.href}
						iconName="external"
						iconAlign="right"
					>
						{button.text}
					</Button>
				))}
			</div>
		),
		[]
	);

	return (
		<div className="awsui-util-ph-xxl">
			<Cards
				cardDefinition={{
					header: renderCardHeader,
					sections: [
						{
							id: 'description',
							content: renderCardDescription,
						},
						{
							id: 'actions',
							content: renderCardActions,
						},
					],
				}}
				cardsPerRow={CARDS_PER_ROW}
				items={CARD_ITEMS}
				loadingText="Loading contact information"
				empty="No contact information available"
			/>
		</div>
	);
};

export default Contact;
